import { SHOW_TIPS, HIDE_TIPS } from 'actions/tips';
import cookie from "react-cookie";

export default (state = { showTips:  cookie.load('ll_hide_tips') !== 'true' }, action) => {
    switch (action.type) {
        case SHOW_TIPS:
            return {showTips: true};

        case HIDE_TIPS:
            return {showTips: false};
    }
    return state;
};
